import { LibNpawPluginFlutterWeb } from './npaw';
import { LibNpawPluginBase } from './npaw-plugin-base';

export function getNpawWebPlugin(): LibNpawPluginBase {
  return new LibNpawPluginFlutterWeb();
}

export default getNpawWebPlugin;
